import React, { useState, useEffect } from 'react';
import './intro.css';
import {Link} from "react-router-dom"

const Intro = () => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showCursor, setShowCursor] = useState(true);
  const fullText = 'Building Wealth, Securing Futures';

  useEffect(() => {
    if (currentIndex < fullText.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + fullText[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex]);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 2000);
    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <div className="intro-container">
      <div className="intro-content">
        <div className="logo-section">
          <div className="logo-circle">
            <img alt="" className="img123" src="https://i.imgur.com/XuWLJ8T.png"/>
          </div>
          <div className="logo-rings">
            <div className="ring ring-1"></div>
            <div className="ring ring-2"></div>
            <div className="ring ring-3"></div>
          </div>
        </div>
        
        <h1 className="company-name">
          <span className="name-part">VIJAYA </span><span className="name-part" style={{color:"white"}}>TRADERS</span>
          <span className="name-divider"></span>
          <span className="name-part"></span>
        </h1>
        
        <div className="tagline-container">
          <p className="tagline">
            {displayedText}
            <span className={`cursor ${showCursor ? 'visible' : ''}`}>|</span>
          </p>
        </div>

        <div className="divider-line"></div>

        <div className="cta-section">
          <button className="cta-button">
            <span className="button-text">Explore Opportunities</span>
            <span className="button-arrow">→</span>
          </button>
        </div>

        <div className="stats-section">
          <div className="stat-item">
            <div className="stat-number">10M+</div>
            <div className="stat-label">Assets Under Management</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">5+</div>
            <div className="stat-label">Years of Excellence</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">10K+</div>
            <div className="stat-label">Satisfied Investors</div>
          </div>
        </div>
      </div>

      <div className="particles">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="particle" style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${5 + Math.random() * 20}s`
          }}></div>
        ))}
      </div>
      
    </div>
  );
};

export default Intro;